// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MultiPaperModal-cls1___1cd3b332fe7cfefeeb0{/*!*/}.MultiPaperModal-cls2___3553e1f5c77356604f1{margin-bottom:40px;font-weight:300;display:flex;flex-direction:column}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "MultiPaperModal-cls1___1cd3b332fe7cfefeeb0",
	"cls2": "MultiPaperModal-cls2___3553e1f5c77356604f1 MultiPaperModal-cls1___1cd3b332fe7cfefeeb0"
};
export default ___CSS_LOADER_EXPORT___;
